module.exports = __webpack_public_path__ + "static/assets/1b63f5631ecfdf2d32b02f5d6de84ea2.png";